import { RootState } from '@cp/src/store';
import { CircularLoaderIcon } from '@navi/web-ui/lib/icons';
import { useSelector } from 'react-redux';
import EstimatesDetails from './EstimatesDetails';
import RaisedForDetails from './RaisedForDetails';
import ResolutionDetails from './ResolutionDetails';
import RcaDetails from './RcaDetails';

const ClosedAnomalyView = () => {
  const isLoading = useSelector(
    (state: RootState) => state?.anomalyTracker?.anomalyDetails?.loading
  );

  if (isLoading)
    return (
      <div className="h-full flex items-center justify-center">
        <CircularLoaderIcon size="lg" />
      </div>
    );

  return (
    <div className="h-full flex flex-col overflow-scroll">
      <div className="p-6">
        <EstimatesDetails />
        <RaisedForDetails />
        <RcaDetails />
        <ResolutionDetails />
      </div>
    </div>
  );
};

export default ClosedAnomalyView;
